import { render, staticRenderFns } from "./AdminRankingTable.vue?vue&type=template&id=afb5ab18&scoped=true"
import script from "./AdminRankingTable.vue?vue&type=script&lang=js"
export * from "./AdminRankingTable.vue?vue&type=script&lang=js"
import style0 from "./AdminRankingTable.vue?vue&type=style&index=0&id=afb5ab18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb5ab18",
  null
  
)

export default component.exports